import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-confirmacion-validar',
  templateUrl: './confirmacion-validar.component.html',
  styleUrls: ['./confirmacion-validar.component.css']
})
export class ConfirmacionValidarComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: MatDialog) { }

  ngOnInit(): void {
  }

}
